module.exports = __webpack_public_path__ + "static/img/PCCL_logo_login.215f67b7.svg";